import { render, staticRenderFns } from "./addTransportCompany.vue?vue&type=template&id=c3162470&scoped=true&"
import script from "./addTransportCompany.vue?vue&type=script&lang=js&"
export * from "./addTransportCompany.vue?vue&type=script&lang=js&"
import style0 from "./addTransportCompany.vue?vue&type=style&index=0&id=c3162470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3162470",
  null
  
)

export default component.exports